var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { validator } from '@ally/validator';
import { IsWithinMaxDate } from '../../shared';
export var IsWithinMaxDateErrorMessage = function (_, _a) {
    var maxAdvanceDuration = _a.maxAdvanceDuration;
    var _b = __read(maxAdvanceDuration, 2), maxAdvancedValue = _b[0], maxAdvancedUnit = _b[1];
    return "You can schedule transfers no more than ".concat(maxAdvancedValue + 1, " ").concat(maxAdvancedUnit, " in advance");
};
export var IsWithinMaxDateValidator = validator(IsWithinMaxDate, IsWithinMaxDateErrorMessage);
//# sourceMappingURL=IsWithinMaxDate.js.map